import { Checkbox, Grid } from '@mui/material';
import React from 'react';
import { TFunction } from 'i18next';
import { TABLE_COLUMNS_IDS } from './tableColumns';
import { IExerciseProperty } from '../../../../types/interfaces/exercise-property';
import AppEntityAvatar, {
  AvatarSize,
} from '../../../../components/designe/app-entity-avatar/AppEntityAvatar';
import { AvatarTypes } from '../../../../components/designe/app-avatar/AppAvatar';
import EditActionButton from '../../../../components/designe/ActionButtons/EditActionButton';
import DeleteActionButton from '../../../../components/designe/ActionButtons/DeleteActionButton';

export function getCellReducers(
  t: TFunction,
  classes: any,
  { canDelete, canEdit },
  onEdit: (property: IExerciseProperty) => void,
  onDelete: (property: IExerciseProperty) => void,
) {
  return [
    {
      id: TABLE_COLUMNS_IDS.AVATAR,
      cellReducer: (property: IExerciseProperty) => {
        return (
          <div className={classes.avatar}>
            <AppEntityAvatar
              entity={property}
              size={AvatarSize.s}
              type={AvatarTypes.round}
            />
          </div>
        );
      },
    },
    {
      id: TABLE_COLUMNS_IDS.NAME,
      cellReducer: (property: IExerciseProperty) => {
        return <div className={classes.name}>{property.name}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.NAME_KEY,
      cellReducer: (property: IExerciseProperty) => {
        return <div className={classes.nameKey}>{property.nameKey}</div>;
      },
    },

    {
      id: TABLE_COLUMNS_IDS.PARENT,
      cellReducer: (property: IExerciseProperty) => {
        return <div className={classes.parent}>{property.parent?.name}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.TYPE,
      cellReducer: (property: IExerciseProperty) => {
        return <div className={classes.type}>{property.type}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.PRIORITY,
      cellReducer: (property: IExerciseProperty) => {
        return <div className={classes.priority}>{property.priority}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.ACTIVE,
      cellReducer: (property: IExerciseProperty) => {
        return (
          <div className={classes.active}>
            <Checkbox disabled checked={property.active}></Checkbox>
          </div>
        );
      },
    },
    {
      id: TABLE_COLUMNS_IDS.IS_DEFAULT,
      cellReducer: (property: IExerciseProperty) => {
        return (
          <div className={classes.active}>
            <Checkbox disabled checked={!!property.isDefault} />
          </div>
        );
      },
    },
    !canEdit && !canDelete
      ? null
      : {
          id: TABLE_COLUMNS_IDS.ACTIONS,
          cellReducer: (property: IExerciseProperty) => {
            return (
              <div className={classes.actions}>
                <Grid
                  className={classes.tdDefault}
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  wrap="nowrap">
                  <Grid
                    container
                    justifyContent="flex-end"
                    alignItems="center"
                    gap={1}
                    wrap="nowrap">
                    {canEdit && (
                      <EditActionButton
                        onClick={() => {
                          onEdit(property);
                        }}></EditActionButton>
                    )}

                    {canDelete && (
                      <DeleteActionButton
                        onClick={() => {
                          onDelete(property);
                        }}></DeleteActionButton>
                    )}
                  </Grid>
                </Grid>
              </div>
            );
          },
        },
  ].filter(Boolean);
}
